var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.valueArray),function(metadata,index){return _c(_vm.dataToComponent(metadata),{key:index,tag:"component",attrs:{"metadata":metadata},on:{"editStringMetaViewer":function($event){return _vm.handleEditStringMetaViewer($event, index)},"editObjMetaViewer":function($event){return _vm.handleEditObjMetaViewer($event, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }